// extracted by mini-css-extract-plugin
export var core = "Breadcrumb-module--core--ef269";